import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent, CardContentComponent, CardHeaderComponent } from '@nk/ui-lib';
import { CompanyAnalysisFraudRiskScoreComponent } from '../company-analysis-fraud-risk-score/company-analysis-fraud-risk-score.component';
import { FraudRiskScoreHelpInfoComponent } from '../fraud-risk-score-help-info/fraud-risk-score-help-info.component';

@Component({
  selector: 'nk-company-analysis-fraud-risk-card',
  imports: [
    TranslateModule,
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    CompanyAnalysisFraudRiskScoreComponent,
    FraudRiskScoreHelpInfoComponent,
  ],
  templateUrl: './company-analysis-fraud-risk-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisFraudRiskCardComponent {
  public companyIdentifier = input.required<string>();
  public printVersion = input(false);
}
